import React, { useContext, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import AuthContext from "../auth/AuthContext";
import { safeNextPath } from "../auth/redirect";
import LoginForm from "../components/Login";
import useDocumentTitle from "../hooks/useDocumentTitle";

function LoginPage() {
  useDocumentTitle("Log ind");
  const { auth, login } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const sessionExpired = searchParams.get("session_expired") === "true";
  const nextPath = safeNextPath(searchParams.get("next"));
  const [error, setError] = useState("");

  if (auth?.user) {
    return <Navigate to={nextPath} replace />;
  }

  const handleLogin = async (username, password) => {
    setError("");
    try {
      await login(username, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(
        typeof detail === "string"
          ? detail
          : "Login mislykkedes. Tjek dine oplysninger."
      );
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 420,
          width: "100%",
          p: { xs: 3, sm: 4 },
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ textAlign: "center", fontWeight: 700, mb: 3 }}
        >
          Log ind
        </Typography>
        {sessionExpired && (
          <Typography color="error" variant="body2" sx={{ mb: 2, textAlign: "center" }}>
            Din session er udløbet. Log venligst ind igen.
          </Typography>
        )}
        <LoginForm onLogin={handleLogin} error={error} />
      </Paper>
    </Box>
  );
}

export default LoginPage;
